export const DEVICE_SELECT_CHANGED = 'onDeviceSelectChanged'



// WEBPACK FOOTER //
// ./src/views/09System-Settings/04Config/03Device/EventKeys.js